<template>
  <DxPopup
    :visible="show"
    :show-title="true"
    :title="$t('stock_management.partners.create_new')"
    :width="'90%'"
    :height="'90%'"
    :wrapper-attr="{ class: 'create-partner-dialog-popup' }"
    @hiding="close"
    @visible-change="onVisibleChange"
  >
    <PartnerAddOrEditContent
      :key="dialogKey"
      :partner-data="modalData"
      :can-edit="true"
      :can-delete="false"
      @onSavePartner="saving"
      @onGotoListPartner="close"
    ></PartnerAddOrEditContent>
  </DxPopup>
</template>

<script>
import DxPopup from "devextreme-vue/popup";
import PartnerAddOrEditContent from "~/pages/stock-management/sm-partners/partials/PartnerAddOrEditContent.vue";

export default {
  name: "CreatePartnerDialog",
  components: { DxPopup, PartnerAddOrEditContent },
  props: {
    show: { type: Boolean, default: false },
    data: { type: Object, default: () => ({}) },
  },
  data: function () {
    return {
      modalData: this.data,
      dialogKey: 0,
    };
  },
  watch: {
    data: function (newVal) {
      this.modalData = newVal;
    },
  },
  methods: {
    onVisibleChange(e) {
      if (!e) {
        this.close();
      }
    },
    close: function () {
      this.$emit("close");
    },
    saving(data) {
      this.$emit("onOK", data);
      this.close();
    },
  },
};
</script>

<style lang="scss">
.create-partner-dialog-popup {
  z-index: 3001 !important;
}

.create-partner-dialog-popup .dx-overlay-content {
  z-index: 3001 !important;
}
</style>
